import {
  AppTrackingTransparency,
  type AppTrackingStatus,
} from 'capacitor-plugin-app-tracking-transparency';
import { reportError } from 'src/modules/logs/Sentry';
import { logAnalyticsEvent } from 'src/modules/analytics/analytics';

let attPromise: Promise<AppTrackingStatus> | null = null;

export const requestATTPermission = (): Promise<AppTrackingStatus> => {
  if (attPromise) return attPromise;

  attPromise = (async () => {
    try {
      const { status } = await AppTrackingTransparency.requestPermission();
      logAnalyticsEvent('att_permission_result', {
        status,
      });
      return status;
    } catch (error) {
      reportError('Error requesting ATT permission', error);
      return 'denied' as AppTrackingStatus;
    }
  })();

  return attPromise;
};

export const getATTStatus = async (): Promise<AppTrackingStatus> => {
  if (attPromise) return attPromise;

  try {
    const { status } = await AppTrackingTransparency.getStatus();
    return status;
  } catch (error) {
    reportError('Error getting ATT status', error);
    return 'denied';
  }
};
